export default {"gitHash":"9dfe91a06a09a2a3656517cb067c59b1c6fde135","gitHashShort":"9dfe91a","time":1650064964162,"platform":"linux","arch":"x64"};